enum CompanionAccommodationExtent {
    All = 'All',
    Any = 'Any',
}

export default CompanionAccommodationExtent;
